import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const blogCategories = RepositoryFactory.get("blogCategories");
const blogs = RepositoryFactory.get("blogs");

export default {
  createCategories({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogCategories.create(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCategories({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogCategories.get(payload);
        commit("SET_BLOG_CATEGORIES", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getBlogs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogs.get(payload);
        commit("SET_BLOG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteBlogs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogs.delete(payload);
        commit("SET_BLOG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateBlogs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogs.update(payload);
        commit("SET_BLOG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  createBlogs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogs.create(payload);
        commit("SET_BLOG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateCategories({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogCategories.update(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteCategories({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await blogCategories.delete(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
